export const zones = {
    "modal": {
      "delete": {
        "title": "¿Está seguro que desea eliminar esta zona?",
        "description": "",
        "error": "Ocurrió un error al eliminar la zona",
        "success": "La zona se eliminó exitosamente"
      }
    },
    "snackbar": {
      "create": {
        "success": "La zona se creó exitosamente",
        "error": "Ocurrió un error al crear la zona"
      },
      "update": {
        "success": "La zona se actualizó exitosamente",
        "error": "Ocurrió un error al actualizar la zona"
      },
      "delete": {
        "success": "La zona se eliminó exitosamente",
        "error": "Ocurrió un error al eliminar la zona"
      }
    },
    "filter": {
      "title": "Zonas",
      "filterTitle": "FILTRAR POR",
      "inputs": {
        "search": "Buscar zona",
        "firstSelect": "Estatus de la zona",
        "rol": "Rol"
      }
    },
    "informationCard": {
      "create": {
        "title": "Nueva zona"
      },
      "edit": {
        "title": "Editar zona"
      },
      "buttons": {
        "add": "AGREGAR ZONA",
        "cancel": "Cancelar",
        "edit": "ACTUALIZAR ZONA"
      }
    }
  }